module.exports = __webpack_public_path__ + "static/home-hero-fd82f4313eb0cf288823a67aa45d7075.jpg";